import TableTemplate from "../../TableTemplate/tableTemplate";
import {
  IAdjustmentTablesSearchParam,
  IDecrementalOptionTableReport,
} from "../../../Interfaces/deltaHedgeAdjustment";
import { CommonTableUI } from "../../TableTemplate/common";
import {
  getCustomDecrementalOptionTable,
} from "../../../Requests/deltaHedgeAdjustment";

interface IProps {
  searchParams: IAdjustmentTablesSearchParam;
}

const DecrementalOptionTable = ({ searchParams }: IProps) => {
  return (
    <TableTemplate<IAdjustmentTablesSearchParam, IDecrementalOptionTableReport>
      TableUI={({ reports, onAction, setSortingType, sortingType }) => (
        <CommonTableUI
          reports={reports}
          onAction={onAction}
          setSortingType={setSortingType}
          sortingType={sortingType}
          tableBoxClassName="max-h-[400px] !max-w-full overflow-x-auto"
        />
      )}
      getDataTable={getCustomDecrementalOptionTable}
      searchParameters={searchParams}
      withSort
      refreshTableTime={5000}
    />
  );
};

export default DecrementalOptionTable;
